import { useCallback, useEffect, useRef, useState } from "react";
import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import EntrySection from "@/pages/home/components/EntrySection";
import AddressSection from "@/pages/home/components/AddressSection";
import TopicSection from "@/pages/home/components/TopicSection";
import NewsSection from "@/pages/home/components/NewsSection";
import RankingSection from "@/pages/home/components/RankingSection";
import AppSection from "@/pages/home/components/AppSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";
import Toast from "@/pages/home/components/Toast";
import NoticeModal from "@/pages/home/components/NoticeModal";
import type { Notice } from "@/pages/home/types";

const installNotice: Notice = {
  title: "App 下载安装",
  lines: [
    "安卓端：获取安装包后按系统提示完成安装；如提示来源限制，请在设置中允许本次安装。",
    "iOS 端：按页面给出的添加方式操作后，可从主屏幕图标直接打开。",
    "安装完成后 App 会自动记忆可用入口，线路变更时推送提醒，随时回到最新地址。",
  ],
  copyText: "51heilian-app.top/download",
  copyLabel: "复制下载地址",
};

export default function Home() {
  const [toast, setToast] = useState<string | null>(null);
  const [notice, setNotice] = useState<Notice | null>(null);
  const [activeTopic, setActiveTopic] = useState<string>("all");
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  const showToast = useCallback((message: string) => {
    setToast(message);
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setToast(null), 2200);
  }, []);

  const handleCopy = useCallback(
    (text: string) => {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).catch(() => undefined);
      }
      showToast(`已复制：${text}`);
    },
    [showToast],
  );

  const openNotice = useCallback((next: Notice) => {
    setNotice(next);
  }, []);

  const handleSearchKeyword = useCallback(
    (keyword: string) => {
      showToast(`已加入搜索：${keyword}`);
    },
    [showToast],
  );

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader onQuickEntry={() => openNotice(installNotice)} />

      <main>
        <HeroSection onCopy={handleCopy} onOpenInstall={() => openNotice(installNotice)} />
        <EntrySection onOpenNotice={openNotice} />
        <AddressSection onCopy={handleCopy} />
        <TopicSection
          activeTopic={activeTopic}
          onSelectTopic={setActiveTopic}
          onSearchKeyword={handleSearchKeyword}
        />
        <NewsSection activeTopic={activeTopic} onOpenNotice={openNotice} />
        <RankingSection onOpenNotice={openNotice} />
        <AppSection onOpenNotice={openNotice} onCopy={handleCopy} />
        <FaqSection />
      </main>

      <SiteFooter />

      <NoticeModal notice={notice} onClose={() => setNotice(null)} onCopy={handleCopy} />
      <Toast message={toast} />
    </div>
  );
}